import axios from "axios";
import {
  FETCH_WALLET_SETTINGS_REQUEST,
  FETCH_WALLET_SETTINGS_SUCCESS,
  FETCH_WALLET_SETTINGS_FAILURE,
} from "./types";
import { WALLET_SETTINGS } from "../api";
export const fetchWalletSettings = (data) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_WALLET_SETTINGS_REQUEST,
    });
    axios
      .post(WALLET_SETTINGS, data)
      .then((response) => {
        dispatch({
          type: FETCH_WALLET_SETTINGS_SUCCESS,
          payload: response?.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: FETCH_WALLET_SETTINGS_FAILURE,
          payload: error.message,
        });
      });
  };
};
